<template>
  <div class="imLineUp">
    <im-top></im-top>
    <div class="text text_top">当前所有客服已经达到上限，请耐心等候</div>
    <div class="text text_bottom">我们很快就来接待您，谢谢</div>
    <div class="imgwrap">
        <img class="errImg" :src="imgUrl+'im-acc.png'" alt="无客服">
        <div class="text innerText">当前等待人数</div>
        <span class="text innerNum">{{currentPosition}}</span>
    </div>
    <a class="btn" :style="{backgroundColor:boxBodyColor}" href="javascript:;" @click="giveUpInLine">放弃排队</a>
    <!--<a href="javascript:window.open('','_parent','');window.close();">Close Window</a>-->
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import imTop from '../im/IMTop.vue'
import imApi from '../../api/imApi'
import * as Urls from '../../components/url'
//import * as ImgUrl from '../../../static/assets'

const imUrl = Urls.baseurl+'/api/visitor/im'
const woUrl = Urls.baseurl+'/api/visitor/wo'
const url = Urls.baseurl+'/api/visitor'

export default {
  name: 'IMLineUp',
  components:{
    imTop
  },
  data () {
    return {
      boxBodyColor:'',
      imgUrl: '/pc/static/assets/',
      msgNum:16,
      visitorMd5Code: null
    }
  },
  computed: {
      ...mapGetters({
        currentPosition: 'currentPosition11',
        // existUser: 'existUser',
        // home: 'home',
        endis:'endclass'
      })

  },

  watch: {
    '$route': 'renderPage'
  },
  mounted(){
    this.$store.state.im.endis=true;
    var gois=true;
     var userAgent = navigator.userAgent;
     if(userAgent.indexOf("Windows")>-1){
        if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(userAgent)) {
             console.log(userAgent)
             gois=false;
        }
    }
    if(gois){
      this.boxBodyColor = sessionStorage.getItem('boxBodyColor')
      this.visitorMd5Code = sessionStorage.md5;
      this.renderPage();
    }else{
      this.$router.push('/beatis')
    }

  },
  methods: {
    renderPage:function () {

      var entranceId = sessionStorage.entranceId ? sessionStorage.entranceId : "";
      //alert(entranceId);
      let visitorMd5Code = sessionStorage.md5; //
      var vm = this;
      // this.$store.dispatch({
      //   type:'entrance',
      //   router: vm.$router,
      //   visitorMd5Code: visitorMd5Code
      // })
      // 创建socket 如果存在链接则忽略
      this.$store.dispatch({
        type:'createSocket',
        router: vm.$router,
        visitorMd5Code: visitorMd5Code
      })
      // 获取当前IM会话状态
      imApi.getSessionStatus (visitorMd5Code,(res)=>{
        console.log(res,"获取当前IM会话状态")

          if( res.code ===1 ) {  // 会话未创建  或者  会话已结束
             let status = res.data.status
            //  vm.$store.commit('setCurrentPosition', res.data.data);
           if(res.data.status == 'waiting') {
              console.log('im会话状态为 排队中')
              // 持续去后台拉取当前排队的数据
              console.log("你快去");
              // vm.$store.dispatch({
              //     type: 'startCurrentPositionTimer',
              //     router: vm.$router,
              //     entranceId: entranceId,
              //     visitorMd5Code: visitorMd5Code,
              // })
           }else if (status === 'chatting') {
              console.log('im会话状态为 聊天中');
              vm.$router.replace({path: '/imSession', query: {v: visitorMd5Code}})
           }else {
              console.log('im会话未创建 现在开始排队')
              vm.$store.dispatch({
                type: 'enterQueue',
                entranceId: entranceId,
                router: vm.$router,
                visitorMd5Code: visitorMd5Code
              })
           }
          }else { // 会话未创建，开始排队
            console.log('im会话未创建 现在开始排队');
            vm.$store.dispatch({
              type: 'enterQueue',
              entranceId: entranceId,
              router: vm.$router,
              visitorMd5Code: visitorMd5Code,
            })

          }
          // // 持续去后台拉取当前排队的数据
          // console.log("你快去");
          vm.$store.dispatch({
              type: 'startCurrentPositionTimer',
              router: vm.$router,
              entranceId: entranceId,
              visitorMd5Code: visitorMd5Code,
          })
      })
    },
    giveUpInLine () {
      // sessionStorage.removeItem("imEntranceMode")
      clearInterval(this.$store.state.im.timer);
      var vm = this;
      let visitorMd5Code = sessionStorage.md5;
      this.$store.dispatch({
        type:'cancelWait',
        router: vm.$router,
        visitorMd5Code: visitorMd5Code
      }).then(() => {
        let isWorkOrder = sessionStorage.redirectTarget
        console.log(isWorkOrder,"isWorkOrder")
        if(isWorkOrder == 5) {
          this.$router.replace({path:'/aiInteractive', query: {v: visitorMd5Code}})
        }else if(isWorkOrder == 3) {
          console.log("跳转到工单")
          this.$router.replace({path:'/workerorderindex'})
        }else {
          console.log("关闭页面")
          // alert("guanbi")
          function CloseWebPage(){
                    if (navigator.userAgent.indexOf("MSIE") > 0) {
                      if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
                      window.opener = null;
                        window.location.href="about:blank";
                      window.close();
                      } else {
                      window.open('', '_top');
                        window.location.href="about:blank";
                      window.top.close();
                      }
                    }
                    else if (navigator.userAgent.indexOf("Firefox") > 0) {
                      window.location.href = 'about:blank ';
                    } else {
                      window.opener = null;
                      window.open('', '_self', '');
                      window.location.href="about:blank";
                      window.close();
                    }
                  }
          setTimeout(()=>{
            CloseWebPage();
          },400)


        }
      })
    }
  }
}
</script>

<style scoped>
.imLineUp{
    /*height: 300px;
    width: 200px;
    background: #595959;*/
}
.imgwrap{
    position: relative;
    width: 159px;
    height: 159px;
    text-align: center;
    margin:40px auto 25px auto;

}
.imgwrap .errImg {
  display: block;
  width: 159px;
  position: absolute;
  top: 0;
  /*margin:40px auto 25px auto;  */
  /*margin:-310px 0 0 -320px;*/
}
.imgwrap .innerText{
    color: #319af2;
    position: relative;
    top: 44px;
}
.imgwrap .innerNum{
    color: #319af2;
    font-size: 40px;
    position: relative;
    top: 60px;
    font-weight: bold;

}
.text {
  text-align: center;
  color: #acb2b6;
}
.text_top{
    margin-top: 50px ;

}
.text_bottom {
    margin-top: 5px;
}
.imLineUp .btn{
    display: block;
    width: 70px;
    height: 30px;
    /*background: #009688;*/
    color: #f4f9f8;
    border-radius: 5px;
    margin: 90px auto  0;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    text-decoration: none;
}
</style>




// WEBPACK FOOTER //
// src/components/im/imLineUp.vue?7e2305b4